import {
  CreateCallRatingInput,
  UpdateCallRatingInput,
} from "@/domain/dtos/inputs";
import { Rating } from "@/domain/entities";
import { RatingRepository } from "@/domain/repositories";
import { RatingDataSource } from "../datasources/ratings";

export class RatingRepoImpl implements RatingRepository {
  constructor(private readonly dataSource: RatingDataSource) {}

  async getCallRatings(filters: {
    psychologist_id?: number;
    page?: number;
  }): Promise<Rating[]> {
    const data = await this.dataSource.getCallRatings(filters);

    // Fazendo o cast porque não há mapeamento de nenhum dado, quando/se houver eu crio o mapper
    return data as Rating[];
  }

  createCallRating(params: CreateCallRatingInput): Promise<unknown> {
    return this.dataSource.createCallRating(params);
  }

  updateCallRating(
    id: number,
    params: UpdateCallRatingInput,
  ): Promise<unknown> {
    return this.dataSource.updateCallRating(id, params);
  }

  async removeCallRating(id: number): Promise<{ message: string }> {
    return this.dataSource.removeCallRating(id);
  }
}
